export var WidgetType;
(function (WidgetType) {
    WidgetType[WidgetType["Grid"] = 0] = "Grid";
    WidgetType[WidgetType["KPI"] = 1] = "KPI";
    WidgetType[WidgetType["Bar"] = 2] = "Bar";
    WidgetType[WidgetType["ValuePair"] = 3] = "ValuePair";
    WidgetType[WidgetType["Donut"] = 4] = "Donut";
    WidgetType[WidgetType["Surface"] = 5] = "Surface";
    WidgetType[WidgetType["TimeSeries"] = 6] = "TimeSeries";
})(WidgetType || (WidgetType = {}));
export var DimensionSelectorEntityType;
(function (DimensionSelectorEntityType) {
    DimensionSelectorEntityType["Portfolio"] = "Portfolio";
    DimensionSelectorEntityType["Fund"] = "Fund";
    DimensionSelectorEntityType["InvestorAccount"] = "InvestorAccount";
    DimensionSelectorEntityType["Asset"] = "Asset";
    DimensionSelectorEntityType["Instrument"] = "Instrument";
    DimensionSelectorEntityType["Market"] = "Market";
    DimensionSelectorEntityType["FundSeries"] = "FundSeries";
})(DimensionSelectorEntityType || (DimensionSelectorEntityType = {}));
export var DatapointFilterMethod;
(function (DatapointFilterMethod) {
    DatapointFilterMethod[DatapointFilterMethod["All"] = 0] = "All";
    DatapointFilterMethod[DatapointFilterMethod["KpiOnlyAmount"] = 1] = "KpiOnlyAmount";
    DatapointFilterMethod[DatapointFilterMethod["MeasuresForChart"] = 2] = "MeasuresForChart";
    DatapointFilterMethod[DatapointFilterMethod["DimensionsForChart"] = 3] = "DimensionsForChart";
    DatapointFilterMethod[DatapointFilterMethod["DimensionsForWorkshopGroupingOption"] = 4] = "DimensionsForWorkshopGroupingOption";
    DatapointFilterMethod[DatapointFilterMethod["MeasuresForTimeseries"] = 5] = "MeasuresForTimeseries";
})(DatapointFilterMethod || (DatapointFilterMethod = {}));
export const widgetNameToWidgetType = new Map([
    ["InsDatapointGridWidget", WidgetType.Grid],
    ["InsKpiDatapointWidget", WidgetType.KPI],
    ["insHorizontalBarDatapointChart", WidgetType.Bar],
    ["InsValuePairDatapointWidget", WidgetType.ValuePair],
    ["InsDonutChart", WidgetType.Donut],
    ["InsTreeMapChart", WidgetType.Surface],
    ["InsTimeSeriesChart", WidgetType.TimeSeries],
    ["insHorizontalBarComparisonChart", WidgetType.Bar],
    ["InsWaterfallComparisonChart", WidgetType.KPI]
]);
export var DetailsPanelType;
(function (DetailsPanelType) {
    DetailsPanelType[DetailsPanelType["AddColumn"] = 0] = "AddColumn";
    DetailsPanelType[DetailsPanelType["Settings"] = 1] = "Settings";
    DetailsPanelType[DetailsPanelType["GroupSettings"] = 2] = "GroupSettings";
    DetailsPanelType[DetailsPanelType["GroupOptions"] = 3] = "GroupOptions";
    DetailsPanelType[DetailsPanelType["Filters"] = 4] = "Filters";
    DetailsPanelType[DetailsPanelType["Default"] = 5] = "Default";
})(DetailsPanelType || (DetailsPanelType = {}));
export var WidgetWorkshopDataset;
(function (WidgetWorkshopDataset) {
    WidgetWorkshopDataset[WidgetWorkshopDataset["Fund"] = 3] = "Fund";
    WidgetWorkshopDataset[WidgetWorkshopDataset["Asset"] = 1] = "Asset";
    WidgetWorkshopDataset[WidgetWorkshopDataset["Manager"] = 15] = "Manager";
    WidgetWorkshopDataset[WidgetWorkshopDataset["Portfolio"] = 15] = "Portfolio";
    WidgetWorkshopDataset[WidgetWorkshopDataset["Investor"] = 31] = "Investor";
    WidgetWorkshopDataset[WidgetWorkshopDataset["Instrument"] = 63] = "Instrument";
    WidgetWorkshopDataset[WidgetWorkshopDataset["NotFound"] = 0] = "NotFound";
})(WidgetWorkshopDataset || (WidgetWorkshopDataset = {}));
